import * as ReactDOMClient from "react-dom/client"
import App from "./App"
import { Providers } from "./components/providers"

// @ts-ignore: allow side-effect CSS import without module declarations
import "../src/css/index.css"
// @ts-ignore: allow side-effect CSS import without module declarations
import "react-image-crop/dist/ReactCrop.css"

import { initStoryblok } from "./appInit/initStoryblok"
import { initPosthog } from "./appInit/initPosthog"
//execution order matters
initStoryblok()
initPosthog()

const rootElement = document.getElementById("root")
if (!rootElement) throw new Error("Failed to find root element")

const root = ReactDOMClient.createRoot(rootElement)
root.render(
  <Providers>
    <App />
  </Providers>
)
